import SVG from "react-inlinesvg";
import { RWebShare } from "react-web-share";
import { decodeHtmlEntitiesSSR } from "@/utils/stringHelper";
import sendGAEvent from "@/utils/gaEvent";

const index = ({
  title,
  url,
  customText,
  contentType = "story",
  sites = [
    "copy",
    "facebook",
    "twitter",
    "whatsapp",
    "mail",
    "linkedin",
    "reddit",
  ],
  isRajasthan,
  isMadhya,
  isHR = false, isUP = false,
  isBH=false,
  isCGH=false,
  isUK=false
}) => {
  return (
    <div
      onClick={() => {
        sendGAEvent({
          eventName: "Share Button",
          pageTitle: title,
          pageLocation: url,
        });
      }}
      className="flex items-center justify-center space-x-1 my-2 "
    >
      <style jsx global>{`
        .rws-icon {
          width: 40px !important;
          height: 40px !important;
          cursor: pointer;
          border: 0;
          background: #1a78f6;
          padding: 0.5rem;
          border-radius: 0.5rem;
          font-size: 0;
        }

        .rws-icons {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          grid-gap: 0.25rem !important;
        }

        .rws-header {
          font-size: 16px !important;
        }
      `}</style>

      <RWebShare
        data={{
          text: customText
            ? decodeHtmlEntitiesSSR(customText)
            : decodeHtmlEntitiesSSR(title),
          url: url,
          title: decodeHtmlEntitiesSSR(title),
        }}
        sites={sites}
      >
        <SVG
          className={`h-8 w-8 ${isRajasthan ? 'text-rajasthanDark':isMadhya ? 'text-mpDark':isHR ? 'text-hrDark':isBH ? 'text-biharDark':isUP ? 'text-upDark': isCGH ?'text-mpDark': isUK ? "text-ukDark":'text-primary'}`}
          src="/assets/icons/svg/social-share/share.svg"
        />
      </RWebShare>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          url
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Facebook"
        onClick={() => {
          sendGAEvent({
            eventName:
              contentType === "video"
                ? "VideoPage-FacebookShare"
                : "ArticlePage-FacebookShare",
            pageTitle: title,
            pageLocation: url,
          });
        }}
      >
        <SVG
          className="h-8 w-8 bg-[#337FFF] rounded-full p-2"
          src="/assets/icons/svg/social-share/facebook.svg"
        />
      </a>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on WhatsApp"
        onClick={() => {
          sendGAEvent({
            eventName:
              contentType === "video"
                ? "VideoPage-WhatsAppShare"
                : "ArticlePage-WhatsAppShare",
            pageTitle: title,
            pageLocation: url,
          });
        }}
      >
        <SVG
          className="h-8 w-8"
          src="/assets/icons/svg/social-share/whatsapp.svg"
        />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
          url
        )}&title=${title ?? ""}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Twitter"
        onClick={() => {
          sendGAEvent({
            eventName:
              contentType === "video"
                ? "VideoPage-TwitterShare"
                : "ArticlePage-TwitterShare",
            pageTitle: title,
            pageLocation: url,
          });
        }}
      >
        <img
          className="h-8 w-8 bg-gray-200 rounded-full p-1"
          src="/assets/icons/svg/social-share/tw.svg"
          alt="social share"
        />
      </a>
    </div>
  );
};

export default index;
